module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-2-3-d101a273c3382e05a8954f54b031e105.png";